'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/@smarterservices/iam-react-client/~/react/react.js
// module id = 816
// module chunks = 0